<template>
  <page-wrap wrapClass="register">
    <land-box isFindPage subTitle="输入新密码">
      <div slot="main" class="form-wrap">
        <el-form ref="accountForm" :rules="accountRules" :model="accountForm" hide-required-asterisk>
          <el-form-item class="form-item" prop="password">
            <el-input
              v-model="accountForm.password"
              auto-complete="off"
              placeholder="请输入密码"
              @keyup.enter.native="handleLogin('account')"
              show-password
            />
          </el-form-item>
          <el-form-item class="form-item" prop="confirmPassword">
            <el-input
              v-model="accountForm.confirmPassword"
              show-password
              placeholder="请再次输入密码"
              @keyup.enter.native="handleLogin('account')"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="foot" class="foot-wrap">
        <el-button :loading="submitBtnLoading" type="primary" class="submit-btn" @click.native.prevent="handleResetPwd">
          <span v-if="!submitBtnLoading">确定</span>
          <span v-else>请 稍 候...</span>
        </el-button>
        <div class="form-bottom ou-flex-lr">
          <span class="web-link" @click="goRegister"> 没有账号，立即注册> </span>
          <span class="web-link" @click="goLogin"> 去登录> </span>
        </div>
      </div>
    </land-box>
  </page-wrap>
</template>

<script>
import PageWrap from './components/PageWrap'
import LandBox from './components/LandBox'
import Verify from '@/components/verifition/Verify'
import { encrypt } from '@/utils/jsencrypt'
import { apiGetAuthConfig, apiUpdatePwd } from '@/api/user/login'

const mobile_reg = /^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/

export default {
  name: 'login',
  components: { PageWrap, LandBox, Verify },
  data() {
    return {
      accountForm: {
        password: '',
        confirmPassword: '',
      },
      bioVerification: '',
      submitBtnLoading: false,
      accountRules: {
        password: [
          { required: true, trigger: 'blur', message: '请输入您的密码' },
          { min: 5, max: 20, validator: this.validPassword, trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, trigger: 'blur', message: '请再次输入您的密码' },
          { required: true, validator: this.equalToPassword, trigger: 'blur' },
        ],
      },
      isPwdEncrypt: 'default',
      preParams: null,
    }
  },
  methods: {
    equalToPassword(rule, value, callback) {
      if (this.accountForm.password !== value) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    },
    validPassword(rule, value, callback) {
      let reg = /^(?=.*\d)(?=.*[a-zA-Z]).{8,20}$/;
      if (!reg.test(value)) {
        callback(new Error('密码必须包含字母和数字，8-20个字符'))
      } else {
        callback()
      }
    },
    handleResetPwd() {
      this.$refs.accountForm.validate().then(() => {
        let { password } = this.accountForm
        let data = {
          ...this.preParams,
          password: this.isPwdEncrypt ? encrypt(password) : password,
        }
        apiUpdatePwd(data)
          .then((res) => {
            console.log(res)
            this.$message.success('密码重置成功')
            setTimeout(() => {
              this.$router.push('/login')
            }, 500)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    goRegister() {
      this.$router.push('/register')
    },
    goLogin() {
      this.$router.push('/login')
    },
  },
  created() {},
  mounted() {
    let preParams = this.$route.query
    this.preParams = preParams
    apiGetAuthConfig().then((res) => {
      Object.assign(this.$data, res.data)
    })
  },
  watch: {},
  computed: {},
}
</script>

<style scoped lang="scss">
.form-wrap ::v-deep {
  .el-tabs__header {
    margin-bottom: 42px;
  }
  .el-tabs__nav.is-stretch {
    background-color: #ffffff;
  }
  .el-tabs__active-bar {
    width: 148px !important;
  }
  .sms {
    .el-tabs__active-bar {
      transform: translateX(0px) !important;
    }
  }
  .account {
    .el-tabs__active-bar {
      transform: translateX(246px) !important;
    }
  }
  .el-tabs__item {
    font-size: 32px;
    height: 48px;
    letter-spacing: 4px;
    padding: 0 5px !important;
    &:nth-child(2) {
      text-align: left;
    }
    &:first-child {
      text-align: left;
    }
    &:last-child {
      text-align: right;
    }
  }
}
.foot-wrap ::v-deep {
  margin-top: 3.77vh !important;
}
</style>
